import { uniqueId } from "../components/util";

export const missouri = {
  _id: uniqueId(),

  type: "Feature",
  id: "USA-MO",
  properties: { fips: "29", name: "Missouri" },
  geometry: {
    type: "Polygon",
    coordinates: [
      [
        [-91.833957, 40.609566],
        [-91.729895, 40.615043],
        [-91.527248, 40.412397],
        [-91.417709, 40.379535],
        [-91.50534, 40.237135],
        [-91.494386, 40.034488],
        [-91.368417, 39.727779],
        [-91.061708, 39.470363],
        [-90.727615, 39.256762],
        [-90.661891, 38.928146],
        [-90.585214, 38.867899],
        [-90.470199, 38.961007],
        [-90.251121, 38.917192],
        [-90.10872, 38.845992],
        [-90.207305, 38.725499],
        [-90.179921, 38.632391],
        [-90.349706, 38.374975],
        [-90.355183, 38.216144],
        [-90.059428, 38.013497],
        [-89.949889, 37.88205],
        [-89.84035, 37.903958],
        [-89.517211, 37.690357],
        [-89.517211, 37.537003],
        [-89.435057, 37.34531],
        [-89.517211, 37.279587],
        [-89.292656, 36.994786],
        [-89.133825, 36.983832],
        [-89.215979, 36.578538],
        [-89.363857, 36.622354],
        [-89.418626, 36.496384],
        [-89.484349, 36.496384],
        [-89.539119, 36.496384],
        [-89.533642, 36.249922],
        [-89.730812, 35.997983],
        [-90.377091, 35.997983],
        [-90.218259, 36.184199],
        [-90.064905, 36.304691],
        [-90.152536, 36.496384],
        [-94.473842, 36.501861],
        [-94.616242, 36.501861],
        [-94.616242, 37.000263],
        [-94.610765, 39.158177],
        [-94.824366, 39.20747],
        [-94.983197, 39.442978],
        [-95.109167, 39.541563],
        [-94.884612, 39.831841],
        [-95.207752, 39.908518],
        [-95.306337, 40.001626],
        [-95.552799, 40.264519],
        [-95.7664, 40.587659],
        [-94.632673, 40.571228],
        [-93.257961, 40.582182],
        [-91.833957, 40.609566]
      ]
    ]
  }
};

export const initialLayer = {
  type: "Point",
  coordinates: [-105.01621, 39.57422]
};

export const featureCollection = {
  type: "FeatureCollection",
  features: [
    {
      type: "Feature",
      properties: {},
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-93.3837890625, 40.07807142745009],
            [-92.10937499999999, 39.33429742980725],
            [-90.3955078125, 40.34654412118006],
            [-91.669921875, 41.409775832009565],
            [-93.3837890625, 40.07807142745009]
          ]
        ]
      }
    }
  ]
};

export const feature = {
  type: "Feature",
  properties: {},
  geometry: {
    type: "Polygon",
    coordinates: [
      [
        [-80.716552734375, 38.199338565983844],
        [-79.046630859375, 38.199338565983844],
        [-79.046630859375, 39.01064750994083],
        [-80.716552734375, 39.01064750994083],
        [-80.716552734375, 38.199338565983844]
      ]
    ]
  }
};
